module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.isVisible,
      "model": true,
      "lockScroll": true,
      "custom-class": 'gallery-dialog'
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('span', [(_vm.images.length > 1) ? _c('div', {
    staticClass: "controls-wrapper"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('span', {
    staticClass: "left",
    on: {
      "click": function($event) {
        return _vm.setPrevIndex()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "right",
    on: {
      "click": function($event) {
        return _vm.setNextIndex()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.images[_vm.selectedIndex]
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62ef96a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/Gallery.vue
// module id = 3307
// module chunks = 3